module.exports = __webpack_public_path__ + "img/preview-3.106d5d22.png";